import React from "react"
import "./StudentPlaceholderPage.style.scss"

const StudentPlaceholderPage = () => {
  return (
    <div className="student-placeholder">
      <p className="student-placeholder__message">Coming Soon</p>
    </div>
  )
}

export default StudentPlaceholderPage
